import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { installHrmosClickTracking } from './utils/careerTracking';

installHrmosClickTracking();

// production ビルドで console.log / info / debug を no-op 化
// （console.warn / error は残す＝本番エラー追跡用）
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = console.info = console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
